import {
    Heart,
    MessageSquareText,
    Sparkles,
} from "lucide-react";

const credibilityPoints = [
    {
        title: "Therapeutic Roots",
        icon: Heart,
        color: "bg-[#ff3366]",
    },
    {
        title: "Real Dialogue",
        icon: MessageSquareText,
        color: "bg-[#16bdf4]",
    },
    {
        title: "Community Impact",
        icon: Sparkles,
        color: "bg-[#ffbc00]",
    },
];

export default function CompanyCredibilityBlock() {
    return (
        <section className="relative overflow-hidden bg-[#f8f4ea] px-6 py-10 lg:px-8">
            <div
                className="absolute inset-0 bg-cover bg-center opacity-10"
                style={{
                    backgroundImage: "url('/assets/schools/problem-texture.png')",
                }}
            />

            <div className="relative mx-auto max-w-6xl">
                <div className="rounded-[26px] border-[5px] border-black bg-white p-5 shadow-[8px_8px_0_#000] md:p-6">
                    <div className="grid gap-6 md:grid-cols-[180px_1fr] md:items-center">
                        {/* Logo / company lockup */}
                        <div className="flex flex-col items-center text-center">
                            <div className="flex h-28 w-28 items-center justify-center overflow-hidden rounded-full border-[4px] border-black bg-[#fff2cf] shadow-[5px_5px_0_#000]">
                                {/* Replace src with your circular logo */}
                                <img
                                    src="empower_games_logo2.png"
                                    alt="Trance4mation Games logo"
                                    className="h-full w-full object-cover"
                                />
                            </div>

                            <div className="mt-4 inline-flex rotate-[-2deg] border-[3px] border-black bg-[#ffbc00] px-3 py-1 text-xs font-black uppercase shadow-[3px_3px_0_#000]">
                                Created By
                            </div>
                        </div>

                        {/* Main content */}
                        <div>
                            <h2 className="text-3xl font-black uppercase leading-none md:text-4xl">
                                Trance4mation Games
                            </h2>

                            <p className="mt-4 max-w-3xl text-base font-bold leading-7 md:text-lg">
                                Founded by therapist Leslie Robinson, Trance4mation Games
                                creates therapeutic dialogue games that help people speak
                                honestly, listen deeply, and heal together.
                            </p>

                            <div className="mt-5 rounded-[16px] border-[3px] border-black bg-[#fff2cf] p-4">
                                <p className="text-sm font-semibold leading-6 md:text-base">
                                    Call It Out Loud brings that mission into schools by giving
                                    students a safe, structured way to talk about bullying,
                                    courage, empathy, and community change.
                                </p>
                            </div>

                            <div className="mt-5 grid gap-3 sm:grid-cols-3">
                                {credibilityPoints.map((point) => {
                                    const Icon = point.icon;

                                    return (
                                        <div
                                            key={point.title}
                                            className="flex items-center gap-3 rounded-[16px] border-[3px] border-black bg-[#f8f4ea] p-3 shadow-[4px_4px_0_#000]"
                                        >
                                            <div
                                                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-[3px] border-black ${point.color} text-white`}
                                            >
                                                <Icon size={18} strokeWidth={3} />
                                            </div>

                                            <p className="text-xs font-black uppercase leading-tight md:text-sm">
                                                {point.title}
                                            </p>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}